import React, { useEffect, useState, memo } from "react";
import PubSub from 'pubsub-js';
import Script from "next/script";

import Service from "../services/service";
import useSocket from "../hooks/useSocket";
import FormCep from  "./formCep";
import ResponsiveModal from './responsiveModal.js'

import { connect } from 'react-redux';
import actions from '../redux/actions';

import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HelpIcon from '@material-ui/icons/Help';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

import InputMask from 'react-input-mask';
import Router from "next/router";
import swal from '@sweetalert/with-react';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';


import { useForm, Controller, useFormContext, useController  } from "react-hook-form";

/**************************************************************/
/* esse cara aqui é quando o contratante ou diarista quer ver */
/* telefones dentro plataforma - via pix */
/**************************************************************/
const Index = (props) => {

    var subscribeModal = null;
    const { control, register, handleSubmit, watch, setValue, getValues, formState: { errors } } = useForm();

    const [model, setModel] = useState({...props.model});
    const [open, setOpen] = useState(props.open || false);
    const [toogles, setHandleToogles] = useState({    
        backdrop: false,
        step: 'information'
    });
    const [pix, setPix] = useState({});
    const [waiting, setAwaiting] = useState(false);

    const copyClipboardConfirmationSaldo = async (text) => {
      await Service.writeText(text);
      handleToggle('copyText', text);
    }

    useEffect(() => {

      subscribeModal = PubSub.subscribe('openFormPayment', (type, model) => {
        setOpen(true);
      });

      return () => {
        PubSub.unsubscribe(subscribeModal);
        subscribeModal = null;
      }  
    }, []);

    useEffect(() => {

      if(open && !props.user && !props.isAuthenticated){
        setOpen(false);
        PubSub.publish('openModal');
        setAwaiting(true);
      }

      if(!open && props.user && props.isAuthenticated && waiting){
        setOpen(true);
        setAwaiting(false);
      }

      if(open){
        setValue("telefones", "25");
        setValue("nome", `${props?.user?.nome} ${props?.user?.sobrenome}`);
        setValue("cpf", props?.user?.cpf);
        setValue("creditType", "CREDITOS");
        setValue("email", props?.user?.email);
        setValue("paymentType", 'PIX');
        setValue("phone_number", props?.user?.telefoneValidado?.replace("55", ""));

        setValue("state", props?.user?.uf);
        setValue("city", props?.user?.cidade);
        setValue("street", props?.user?.endereco);
        setValue("number", props?.user?.numero);
        setValue("neighborhood", props?.user?.bairro);

        setValue("zipcode", props?.user?.cep);
      }
    }, [open, props])

    const handleToggle = (name, flag) => {
      setHandleToogles((toogles) => ({...toogles, [name]: flag}));
    }

    const handlePaymentType = (type) => {
      setValue('paymentType', type)
    }

    const amount = Service.amount;
    const handleCloseNavigate = () => {
      setOpen(false);
      handleToggle('step', 'information');
    }

    const handleSubmitPropose = async (data) => {

      if(toogles.step === 'information'){
        handleToggle('step', 'formulario');
        return
      }


      if(toogles.step === 'formulario' && watch("paymentType") === 'CRIPTO-MOEDA'){

        data.amount = getValues("creditType") === 'GIFT' ? (getValues("telefones")*100).toFixed(2) : (getValues("telefones")*Service.PRICE_CREDITS).toFixed(2);
        data.name = 'Compra de créditos na Odete';
        data.description = 'Compra de créditos na Odete';
        data.currency = 'BRL';
        data.CREDIT_TYPE = getValues("creditType");

        PubSub.publish("backdrop", true);
        var response = await Service.createCharges(data)
        console.log(response)
        setPix(response);
        handleToggle('step', 'CRIPTO');
        PubSub.publish("backdrop", false);

        return;
      }

      if(toogles.step === 'formulario'){

        data.cpf = data.cpf.toString().replace(/\D/g, "");

        if(!Service.validCpfCnpj(data.cpf)){
          swal('', 'cpf inválido', 'error');
          return false;
        }

        if(watch("paymentType") === 'CARTAO-CREDITO'){
          handleToggle('step', 'cartao');          
        }else{
          handleToggle('step', 'confirmation');          
        }
      }

      if(toogles.step === 'cartao'){
        handleToggle('step', 'confirmation');
      }

      if(toogles.step === 'confirmation'){
        PubSub.publish('backdrop', true);


        /* AQUI COMECA AS VALIDACOES DE CARTAO */
        if(watch("paymentType") === 'CARTAO-CREDITO'){

          var token = await generatePaymentToken();
          if(!token){
            alert('NÃO FOI POSSÍVEL TOKEZINAR SEU CARTÃO');
            PubSub.publish('backdrop', false);
            return false;
          }
        }

        data.amount = getValues("creditType") === 'GIFT' ? (getValues("telefones")*100).toFixed(2) : (getValues("telefones")*Service.PRICE_CREDITS).toFixed(2)
        data.type = 'CONTRATANTE';
        data.userId = props?.user?._id;
        data.payment_token = token;

        if(watch("paymentType") === 'CARTAO-CREDITO'){
          Service.post(`${Service.api}/integrations/gerencianet/createOneStepCharge`, data).then(resp => {

            if(!resp.success){
              alert(resp.error_description.message)
              PubSub.publish('backdrop', false);
            }else{

              setPix(resp);
              handleToggle('step', 'completed');
              PubSub.publish('backdrop', false);
              props.getUser();                              

            }
          }).catch(e => {
            console.log(e)
            alert('Erro')
          })          
        }

        if(watch("paymentType") === 'PIX'){
          Service.post(`${Service.api}/integrations/gerencianet/pixCreateCharge`, data).then(resp => {
            setPix(resp);
            handleToggle('step', 'payment');
            PubSub.publish('backdrop', false);
          })          
        }
      }
    }

    const handleUpdatePix = (transaction) => {

      if(transaction.solicitacaoPagador === props?.user?.email && transaction.status === 'CONCLUIDA'){
        handleToggle('step', 'completed');
        Service.scrollIntoView('__next');

        swal({content: <div>

          <h3 className="barlow fw-bold">Maravilha!</h3>
          <p className="text-center">O seu pagamento foi aceito!</p>
          <h3 className="barlow fw-bold">Na Odete você pode MUITO mais!</h3></div>, icon: '/assets/images/icons/star-success.png'}).then(() => {
          handleCloseNavigate();
          props.getUser();
        });
      }
    };

    const souProfissional = () => {
      handleCloseNavigate()
      Router.push('/register')
    };

    const socket = useSocket(Service.api);

    useEffect(() => {
      if(socket && open){
        socket.on("newPayment", handleUpdatePix);
      }

      return ()=> {
        if(socket){
          socket.off("newPayment");
        }
      }
    }, [socket, open]);

    const changeType = (type) => {
      setValue("creditType", type)
      setValue("telefones", (type === 'GIFT' ? 5 : 25))
    }

    const help = (type) => {

      changeType(type)

      var helper = {
        'GIFT': {
          title: 'VALE ODETE',
          message: 'VALE ODETE É COMO SE FOSSE UM VALE PRESENTE, ONDE É GERADO UM CUPOM E VOCÊ INSERE NO FINAL DO SERVIÇO REALIZADO PELA PESSOA CONTRATADA.'
        },
        'CREDITOS': {
          title: 'CRÉDITOS',
          message: 'CRÉDITOS SÃO USADOS PARA ABRIR OS TELEFONES DE DIARISTAS E REALIZAR DISPAROS.'
        }
      }

      const h = helper[type]

      swal({content: <div className="pt-2"><p className="text-center">{h.title}</p><h6 className="barlow fw-bold">{h.message}</h6>

                {watch("creditType") === 'GIFT' ? 
                <ul className="list-group list-inside list-inline">
                  <li>1 GIFT {'=>'} R$ 100,00;</li>
                </ul>: <ul className="list-group list-inside list-inline">
                  <li>1 CRÉDITO {'=>'} {Service.formatCurrency(Service.PRICE_CREDITS)};</li>
                  {props?.user?.type !== 'CONTRATANTE' && <li>{Service.CREDIT_BY_CALCULADORA} crédito por usar a calculadora de preço;</li>}
                  <li>{Service.CREDIT_BY_TELEFONE} créditos por telefone visualizado;</li>
                  {props?.user?.type !== 'CONTRATANTE' && <li>{Service.CREDIT_BY_WHATSAPP} créditos por whatsapp recebido;</li>}
                  {props?.user?.type !== 'CONTRATANTE' && <li>{Service.CREDIT_BY_IMAGEM_IA} créditos por geração de imagem;</li>}
                  <li>{Service.CREDIT_BY_DISPARO} créditos por disparo realizado;</li>
                </ul>}


      </div>, icon: 'success'});
    }

    const identifyBrand = async () => {
      try {
        const brand = await EfiPay.CreditCard
          .setCardNumber(watch("numeroCartao").replace(/\D/g, ""))
          .verifyCardBrand();

          return brand
      } catch (error) {

        console.log(error);

        alert('Bandeira Inválido')
        console.log("Código: ", error.code);
        console.log("Nome: ", error.error);
        console.log("Mensagem: ", error.error_description);
        return false;
      }
    }

    const generatePaymentToken = async () => {

      var brand = await identifyBrand();

      if(!brand){
        return false;
      }

      try {
        const result = await EfiPay.CreditCard
          .setAccount("0e5d74478b378b2fee1263188f0e24b6")
          .setEnvironment("production")
          .setCreditCardData({
            brand: brand,
            number: watch("numeroCartao").replace(/\D/g, ""),
            cvv: watch("cvv").replace(/\D/g, ""),
            expirationMonth: watch("expirationMonth").replace(/\D/g, ""),
            expirationYear: watch("expirationYear").replace(/\D/g, ""),
            holderName: watch("nome"),
            holderDocument: watch("cpf").replace(/\D/g, ""),
            reuse: true,
          })
          .getPaymentToken({ reuse: true });

        const payment_token = result.payment_token;
        const card_mask = result.card_mask;

        setValue('payment_token', payment_token)
        return payment_token;

      } catch (error) {

        console.log("Código: ", error.code);
        console.log("Nome: ", error.error);
        console.log("Mensagem: ", error.error_description);

        alert('Cartão Inválido')
        return false;
      }
    }

    const showAddress = (resp) => {
      if (!resp) {
        swal('', "Ixe! Cep não encontrado", 'error');
        return false;
      }

      setValue("zipcode", resp.cep);
      setValue("state", resp.uf);
      setValue("city", resp.cidade);
      setValue("street", resp.endereco);
      setValue("number", resp.numero);
      setValue("neighborhood", resp.bairro);
    }

  return (<>
    {open && <ResponsiveModal anchor="bottom" open={open} onClose={handleCloseNavigate} keepMounted className={`contratatePremium formPayment overflow-hidden`} style={{zIndex: (theme) => theme.zIndex.modal + 1}} data-component="formPayment">
      <Script strategy="afterInteractive" async src="/assets/js/payment-token-efi.js" />
      <form onSubmit={handleSubmit(handleSubmitPropose)} name="form" className="d-flex flex-column h-100 overflow-hidden">
        {toogles.step === 'information' && <DialogTitle id="alert-dialog-slide-title">
          <div className="d-flex align-items-center justify-content-between">
            <div>Odete.com.br</div>
            <IconButton aria-label="close" onClick={handleCloseNavigate}>
              <CloseIcon titleAccess="fechar modal" />
            </IconButton>
          </div>
        </DialogTitle>}
        <DialogContent dividers>
          <Slide in={toogles.step === 'information'} mountOnEnter unmountOnExit>
            <div>
                <img src={Service.parseURLImage(props?.user)} alt="Contratante adquirindo créditos" className="rounded-circle img-thumbnail mb-2 m-auto d-flex" width="64" height="64" />
                <p className="text-center fw-bold">Olá {props?.user?.nome}, você está com {props?.user?.creditos || 0} créditos</p>
                <div className="text-center">
                  <p className="lead">Legal saber que você está sentindo confiança na plataforma!</p>
                  {
                    props?.user?.type === 'CONTRATANTE' && <>
                        <p>Adquira créditos para visualizar o telefone de profissionais diaristas ou vale odete para efetuar pagamentos.</p>
                      </>
                  }

                  {props?.user?.type !== 'CONTRATANTE' && <>
                        <p>Adquira créditos para utilizar alguns recursos extras da plataforma.</p>
                      </>
                  }

                </div>
            </div>
          </Slide>

          <Slide direction="left" in={toogles.step === 'formulario'} mountOnEnter unmountOnExit>
            <div>
              <fieldset>
                <legend className="barlow fs-6 fw-bold text-uppercase">Que tipo de crédito você deseja?</legend>
                <div className="d-flex gap-3">
                  <div className="w-100">
                      <div className="form-check d-flex align-items-center gap-2">
                        <input onChange={() => changeType('CREDITOS')} checked={getValues("creditType") === 'CREDITOS'} value="CREDITOS"  className="form-check-input" type="radio" id="CREDITS" />
                        <label className="form-check-label d-flex align-items-center" htmlFor="CREDITS">
                          CRÉDITOS <IconButton onClick={() => help('CREDITOS')}><HelpIcon /></IconButton>
                        </label>
                      </div>
                    </div>
                  <div className="w-100">
                    <div className="form-check d-flex align-items-center gap-2">
                      <input onChange={() => changeType('GIFT')} checked={getValues("creditType") === 'GIFT'} value="GIFT" className="form-check-input" type="radio" id="GIFT" />
                      <label className="form-check-label d-flex align-items-center" htmlFor="GIFT">
                        VALE ODETE <IconButton onClick={() => help('GIFT')}><HelpIcon /></IconButton>
                      </label>
                    </div>
                  </div>

                </div>
                <div className="form-group mb-3">
                  <label className="form-label" htmlFor="credits">Quantos créditos você deseja adquirir?</label>
                    <div className="d-flex">
                      <label className={`btn ${watch('telefones') === '25' && 'btn-outline-secondary'}`} htmlFor="option5"><input type="radio" className="btn-check" name="telefones" value={25} id="option5" {...register("telefones")} />25</label>
                      <label className={`btn ${watch('telefones') === '50' && 'btn-outline-secondary'}`} htmlFor="option6"><input type="radio" className="btn-check" name="telefones" value={50} id="option6" {...register("telefones")} />50</label>
                      <label className={`btn ${watch('telefones') === '100' && 'btn-outline-secondary'}`} htmlFor="option7"><input type="radio" className="btn-check" name="telefones" value={100} id="option7" {...register("telefones")} checked={watch('telefones') === "100"} />100</label>
                      <label class={`btn ${watch('telefones') === '500' && 'btn-outline-secondary'}`} htmlFor="option8"><input type="radio" className="btn-check" name="telefones" value={500} id="option8" {...register("telefones")}  checked={watch('telefones') === "500"} />500</label>
                    </div>


                </div>
             </fieldset>

              <fieldset className="">
                <legend className="barlow fs-6 fw-bold text-uppercase">Dados do Pagador</legend>
                <div className="row">                    
                  <div className="col-6">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="document">CPF</label>
                      <InputMask
                        {...register("cpf")}
                        type="tel"
                        id="document"
                        mask="999.999.999-99"
                        placeholder="XXX.XXX.XXX-XX"
                        required={true}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="phone_number">
                        Telefone
                      </label>
                      <InputMask
                        {...register("phone_number")}
                        type="text"
                        id="phone_number"
                        placeholder="Telefone"
                        mask="(99) 99999-9999"
                        className="form-control"
                        required={true}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="name">Nome</label>
                      <input
                        {...register("nome")}
                        type="text"
                        id="name"
                        placeholder="Nome"
                        required={true}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="email">E-mail</label>
                      <input
                        {...register("email")}
                        type="email"
                        id="email"
                        placeholder="E-mail"
                        required={true}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>


                <legend className="barlow fs-6 fw-bold text-uppercase">FORMA DE PAGAMENTO</legend>
                <div className=" mb-4  w-100 d-flex gap-2">
                  <input className="btn-check" {...register("paymentType")} type="radio" name="paymentType" id="pix" value="PIX" />
                  <label className="btn btn-outline-primary w-100 d-flex flex-column align-items-start text-start" htmlFor="pix">
                    <img src="/assets/images/selos/pix.png" width="35" height='35' /><small className="p-0 mt-2">PIX</small>
                  </label>
                  <input className="btn-check" {...register("paymentType")} type="radio" name="paymentType" id="cartao" value="CARTAO-CREDITO" />
                  <label className="btn btn-outline-primary w-100 d-flex flex-column align-items-start text-start" htmlFor="cartao">
                    <CreditCardIcon fontSize='large' /><small className="p-0 mt-2">CRÉDITO</small>
                  </label>
                  <input className="btn-check" {...register("paymentType")} type="radio" name="paymentType" id="cripto" value="CRIPTO-MOEDA" />
                  <label className="btn btn-outline-primary w-100 d-flex flex-column align-items-start text-start" htmlFor="cripto">
                    <MonetizationOnIcon fontSize='large' /><small className="p-0 mt-2">CRIPTO</small>
                  </label>
                </div>

              </fieldset>
            </div>
          </Slide>

          <Slide direction="left" in={toogles.step === 'cartao'} mountOnEnter unmountOnExit>
            <div>
              <h4>Não salvamos suas informações!</h4>
              <div className="row">

                <div className="col-12 col-sm-6">
                    <div className="form-group mb-3">
                      <label htmlFor="numeroCartao" className="form-label">Número do cartão *</label>
                      <InputMask
                        {...register("numeroCartao")}
                        type="tel"
                        id="numeroCartao"
                        mask="9999-9999-9999-9999"
                        placeholder="XXXX-XXXX-XXXX-XXXX"
                        required={true}
                        className="form-control"
                      />
                    </div>
                </div>
                <div className="col-9 col-sm-4">
                    <div className="form-group mb-3">
                      <label htmlFor="mesVencimento" className="form-label">MÊS/ANO</label>
                      <div className="d-flex input-group">
                        <select className="form-select" required={true} name="expirationMonth" id="expirationMonth" {...register("expirationMonth")} >
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                        </select>
                        <input required={true} {...register("expirationYear")} placeholder="YYYY" type="tel" min="1900" max="9999" maxLength="4" className="form-control" name="expirationYear" id="expirationYear" />
                      </div>
                    </div>
                </div>
                <div className="col-3 col-sm-2">
                    <label htmlFor="cvv" className="form-label">CVV *</label>
                    <input {...register("cvv")} required={true} placeholder="XXX" type="tel" min="000" max="999" maxLength="3" className="form-control" name="cvv" id="cvv" />
                </div>
              </div>
              <div className="row">
                
                <div className="col-12 col-sm-4">
                  <FormCep onFormatAddress={showAddress} initialValue={watch('zipcode')} />
                </div>

                <div className="col-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="uf">Estado</label>
                    <select
                      name="uf"
                      id="uf"
                      className="form-control form-select"
                      required={true}
                      {...register("state")}
                      disabled
                    >
                      <option value="">Selecione</option>
                      <optgroup label="Uf">
                        <option value="AC">AC</option>
                        <option value="AL">AL</option>
                        <option value="AP">AP</option>
                        <option value="AM">AM</option>
                        <option value="BA">BA</option>
                        <option value="CE">CE</option>
                        <option value="DF">DF</option>
                        <option value="ES">ES</option>
                        <option value="GO">GO</option>
                        <option value="MA">MA</option>
                        <option value="MT">MT</option>
                        <option value="MS">MS</option>
                        <option value="MG">MG</option>
                        <option value="PA">PA</option>
                        <option value="PB">PB</option>
                        <option value="PR">PR</option>
                        <option value="PE">PE</option>
                        <option value="PI">PI</option>
                        <option value="RJ">RJ</option>
                        <option value="RN">RN</option>
                        <option value="RS">RS</option>
                        <option value="RO">RO</option>
                        <option value="RR">RR</option>
                        <option value="SC">SC</option>
                        <option value="SP">SP</option>
                        <option value="SE">SE</option>
                        <option value="TO">TO</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="cidade">
                      Cidade
                    </label>
                    <input
                      type="text"
                      placeholder="Cidade"
                      id="cidade"
                      name="cidade"
                      className="form-control"
                      required={true}
                      {...register("city")}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-9">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="endereco">Endereço</label>
                    <input
                      type="text"
                      placeholder="Endereço"
                      name="endereco"
                      required={true}
                      id="endereco"
                      className="form-control"
                      {...register("street")}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="numero">Número</label>
                    <input
                      type="text"
                      placeholder="Nº"
                      id="numero"
                      name="numero"
                      required={true}
                      className="form-control"
                      {...register("number")}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bairro">
                      Bairro
                    </label>
                    <input
                      type="text"
                      placeholder="Bairro"
                      name="bairro"
                      id="bairro"
                      className="form-control"
                      required={true}
                      {...register("neighborhood")}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Slide>

          <Slide direction="left" in={toogles.step === 'CRIPTO'} mountOnEnter unmountOnExit>
            <div className="container-fluid">
              <div className="row">
                <div className="col">

                  <div className="text-center">
                    <p className="text-success"><VerifiedUserIcon fontSize="large" /></p>
                    <p className="fw-bold lead">O acesso ao sistema é liberado automaticamente após o pagamento!</p>
                    {getValues("creditType") === 'GIFT' ? <p className="lead">Você está adquirindo {getValues("telefones")} GIFT CARDS por: <strong>{Service.formatCurrency(getValues("telefones")*100)}</strong></p> : <p className="lead">Você está adquirindo {getValues("telefones")} créditos por: <strong>{Service.formatCurrency(getValues("telefones")*Service.PRICE_CREDITS)}</strong></p>}
                    <p>Esse link de pagamento expira em: {Service.formatDate(pix.expires_at, 'dd/MM/yyyy HH:mm')}</p>
                    <p>Código da cobrança: {pix.code}</p>
                    <a href={pix.hosted_url} target="_blank" rel="noreferrer" className="mb-4 d-block text-uppercase btn btn-link">
                      abrir link de pagamento
                    </a>
                  </div>

                </div>
              </div>
            </div>
          </Slide>

          <Slide direction="left" in={toogles.step === 'confirmation'} mountOnEnter unmountOnExit>
            <div className="text-center">
              <p className="text-success"><VerifiedUserIcon fontSize="large" /></p>
              {getValues("creditType") === 'GIFT' ? <p>Olá {getValues("nome")}, você está adquirindo {getValues("telefones")} GIFT CARDS por: <strong>{Service.formatCurrency(getValues("telefones")*100)}</strong></p> : <p>Olá {getValues("nome")}, você está adquirindo {getValues("telefones")} créditos por: <strong>{Service.formatCurrency(getValues("telefones")*Service.PRICE_CREDITS)}</strong></p>}              
              {watch("paymentType") === 'CARTAO-CREDITO' && <p className="fw-bold barlow lead">O acesso ao sistema é liberado automaticamente após o pagamento!</p>}
              {watch("paymentType") === 'PIX' && <p className="fw-bold barlow lead">Será gerado um PIX e quando efetuado o pagamento, o acesso será liberado automaticamente.</p>}
            </div>
          </Slide>

          <Slide direction="left" in={toogles.step === 'payment'} mountOnEnter unmountOnExit>
            <div className="text-center">
              <p>É tudo instantâneo, rápido e seguro - o acesso a plataforma é liberado imediatamente.</p>
              {
                watch("paymentType") === 'PIX' &&
                <>
                  <p className="fw-bold barlow text-uppercase m-0">Aponte sua câmera aqui!</p>
                  <img alt="gerando qr-code pix" src={pix?.generate?.imagemQrcode} />
                  <p>ou</p>
                  <button type="button" onClick={() => copyClipboardConfirmationSaldo(pix?.generate?.qrcode)} className={`w-100 btn btn-block ${toogles.copyText ? 'btn-success' : 'btn-outline-success'}`}>
                    {!toogles.copyText && <><CheckCircleOutlineIcon /> <small className="d-block">copiar código do pix</small></>}
                    {toogles.copyText && <><CheckCircleIcon /> <small className="d-block">copiado</small></>}
                  </button>
                </>
              }

            </div>
          </Slide>

          <Slide direction="left" in={toogles.step === 'error'} mountOnEnter unmountOnExit>
            <div className="text-center">
              <p className="text-danger barlow fw-bold">Olá {props?.user?.nome}, infelizmente ocorreu um erro na tentativa de efetuar o pagamento.</p>
              <button type="button" onClick={() => handleToggle('step', 'payment')} className="text-uppercase barlow btn-primary btn px-4 fw-bold w-100">Tentar Novamente</button>
              <small>suas informações já estão preenchidas</small>
            </div>
          </Slide>

          <Slide direction="left" in={toogles.step === 'completed'} mountOnEnter unmountOnExit>
            <div className="text-center">
              <img alt="Crédito adquiridos com sucesso" src="/assets/images/icons/star-success.png" className="mb-2" />
              <h3 className="barlow fw-bold">Maravilha!</h3>
              <p className="lead text-muted fw-bold">Sua conta foi liberada e você já pode requisitar os telefones novamente!</p>
              <p className="lead">Obrigado pela confiança e a oportunidade de melhorarmos a Odete.com.br cada vez mais!</p>
            </div>
          </Slide>
        </DialogContent>
        {
          toogles.step === 'information' &&
            <DialogActions>
              <div className="w-100">
                <button type="submit" className="btn btn-primary w-100 text-uppercase barlow fw-bold btn-lg">continuar</button>
              </div>
            </DialogActions>
        }



        {
          (toogles.step === 'formulario') && 
            <DialogActions>
              <div className="flex-fill d-flex gap-2">
                <button type="button" onClick={handleCloseNavigate} className="w-100 btn btn-outline-secondary btn-lg btn-block text-uppercase fw-bold barlow">Cancelar</button>
                <button type="submit" className="w-100 btn btn-primary btn-lg btn-block text-uppercase fw-bold barlow">Continuar</button>
              </div>
            </DialogActions> 
        }

        {
          (toogles.step === 'cartao') && 
            <DialogActions>
              <div className="flex-fill d-flex gap-2">
                <button type="button" onClick={() => handleToggle('step', 'formulario')} className="w-100 btn btn-outline-secondary btn-lg btn-block text-uppercase fw-bold barlow">Voltar</button>
                <button type="submit" className="w-100 btn btn-primary btn-lg btn-block text-uppercase fw-bold barlow">Continuar</button>
              </div>
            </DialogActions> 
        }


        {
          (toogles.step === 'confirmation') && 
            <DialogActions>
              <div className="flex-fill d-flex gap-2">
                <button type="button" onClick={() => handleToggle('step', 'formulario')} className="w-100 btn btn-outline-secondary btn-lg btn-block text-uppercase fw-bold barlow">Voltar</button>
                <button type="submit" className="w-100 btn btn-primary btn-lg btn-block text-uppercase fw-bold barlow">Finalizar</button>
              </div>
            </DialogActions> 
        }
        {
          toogles.step === 'completed' && 
            <DialogActions>
                  <div className="flex-fill d-flex gap-2">
                    <div className="col">
                      <button type="button" onClick={handleCloseNavigate} className="w-100 btn btn-primary btn-lg btn-block text-uppercase fw-bold barlow">FECHAR E NAVEGAR</button>
                    </div>                        
                  </div>
            </DialogActions> 
        }
      </form>
    </ResponsiveModal>}</>
  );
}

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.authentication.token,
    token: state.authentication.token,
    user: state.authentication.user
  }
);

export default connect(mapStateToProps, actions)(Index);